class BarChart extends React.Component {
  componentDidMount() {
    this.updateChart(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.updateChart(nextProps);

    return false;
  }

  getNodeData(props) {
    let widthOf = function (val) {
      return Math.abs((val / (props.domain[1] - props.domain[0])) * props.width);
    };

    let axis = widthOf(-props.domain[0]);
    let x = axis - widthOf(props.data.reduce(function (a, b) {
      return a + (b < 0 ? b : 0);
    }, 0));

    return props.data.map(function (val, i) {
      let w = widthOf(val);

      x += w;

      return {
        x: x - w,
        width: w,
        value: val,
        tip: props.tip(val, i)
      };
    });
  }

  updateChart(props) {
    let data = this.getNodeData(props);

    let { colors, height, transition } = props;

    let selection = d3.select(ReactDOM.findDOMNode(this))
      .select("g")
      .selectAll("rect");

    let rects = selection
      .data(data);

    rects
      .exit()
      .remove();

    rects = rects
      .enter()
      .append("rect")
      .merge(rects);

    rects
      .attr("height", height)
      .attr("fill", function (d, i) {
        return colors[i];
      })
      .attr("data-tooltip", function (d, i) {
        return d.tip;
      });

    rects
      .transition()
      .duration(transition)
      .attr("x", function (d, i) {
        return d.x || 0;
      })
      .attr("width", function (d, i) {
        return d.width || 0;
      });
  }

  render() {
    let { width, height, background, margin = "0 1em 1em 0" } = this.props;

    return (
      <svg className="mc-chart" width={width} height={height} style={{ background, margin }}>
        <rect width={width} height={height} fill="rgba(0,0,0,0.05)"/>
        <g/>
      </svg>
    );
  }
}

BarChart.defaultProps = {
  colors: [], // required
  data: [], // required
  width: 200,
  height: 15,
  domain: [0, 1],
  background: "none",
  transition: 500,
  tip: function (val, idx) {
    return val;
  }
};

module.exports = BarChart;
